<!--
 * @Descripttion: 
 * @version: 
 * @Author: 杨海波
 * @Date: 2021-12-08 10:19:50
 * @LastEditors: A21
 * @LastEditTime: 2022-05-17 18:28:10
 * @FilePath: /intell-loan/src/views/pages/publicPage/Perfect/components/common/ApplicationType.vue
-->
<template>
  <div class="ApplicationType temr">
    <div :class="`title ${params.field}`">申请人类型</div>
    <div
      v-for="item in list"
      :key="item.id"
    >
      <div
        class="radioBox"
        @click="params.disabled?null:changeHnadler(item)"
      >
        <img
          src="@/assets/images/radioSelect.png"
          alt=""
          class="selectIcon"
          v-if="radio == item.id"
        >
        <img
          src="@/assets/images/radioNoSelect.png"
          alt=""
          class="selectIcon"
          v-else
        >
        <span class="text">{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex';

export default {
  name: 'ApplicationType',
  data() {
    return {
      radio: '',
      list: [
        {
          name: '法人',
          id: '1',
        },
        {
          name: '股东',
          id: '2',
        },
      ],
    };
  },
  props: ['form', 'params'],
  watch: {
    radio: {
      handler(newVal) {
        this.updateState({
          borrowerType: newVal,
        });
        this.$emit('input', newVal);
      },
      immediate: true,
    },
    'params.initValue': {
      handler(val) {
        this.radio = val;
      },
    },
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    changeHnadler(item) {
      this.radio = item.id;
      // 未实名认证时 切换清空姓名
      if (!this.publicPage.personAuthStatus) {
        this.form.setInitialValues({
          borrowerName: '',
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.ApplicationType {
  position: relative;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px 16px;
  background: #fff;
  .radioBox {
    display: flex;
    align-items: center;
    margin-right: 24px;
    .selectIcon {
      width: 24px;
      height: 24px;
    }
    .text {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #46494d;
      line-height: 21px;
      font-weight: 400;
    }
  }
}
.title {
  font-size: 14px;
  color: #46494d;
  text-align: left;
  word-wrap: break-word;
  width: 86px;
  margin-right: 16px;
}
.vanRadioGroup {
  display: flex;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
</style>
